import Vue from "vue";
import VueMoment from "vue-moment";

const moment = require("moment");
require("moment/locale/id");

window.moment = moment;

Vue.use(VueMoment, { moment });
